import React from "react";
import "./Testimonials.css";

function Testimonials() {
  return (
    <div className="testimonials-4">
      <div className="group-33-2">
        <img className="ellipse-6-1" src="/img/ellipse-6@2x.png" />
      </div>
      <div className="flex-col-4">
        <div className="vatsala-wilson-1 poppins-medium-tundora-17px">Vatsala Wilson</div>
        <p className="lorem-ipsum-dolor-si-1 montserrat-normal-tundora-14px">
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. In nec posuere mauris, ut lacinia lectus. Donec ut
          enim mauris. Sed molestie Lorem ipsum dolor sit amet,
        </p>
      </div>
    </div>
  );
}

export default Testimonials;
